__turbopack_context__.v({
  "dialogContent": "AccountActionsMultiAccount-module__DxTOSG__dialogContent",
  "filters": "AccountActionsMultiAccount-module__DxTOSG__filters",
  "hwidFilter": "AccountActionsMultiAccount-module__DxTOSG__hwidFilter",
  "root": "AccountActionsMultiAccount-module__DxTOSG__root",
  "table": "AccountActionsMultiAccount-module__DxTOSG__table",
});
